import { upperFirst } from 'lodash';

function capitalize(string: string) {
  if (!string) {
    return '';
  }

  return string[0].toUpperCase() + string.slice(1);
}

export const capitalizeFromUppercase = (str: string) => upperFirst(str.toLowerCase());
export const capitalizeWordFirstCaracter = (str: string): string =>
  str
    ?.toLowerCase()
    .split(' ')
    .map((w) => upperFirst(w))
    .join(' ');
export { capitalize };
